import { createSlice } from '@reduxjs/toolkit';

export const events = createSlice({
  name: 'EVENTS',
  initialState: [],
  reducers: {
    setQuestionsWithSideEffectsTriggered(state, action) {
      const { componentId } = action.payload;
      return {
        ...state,
        questionsWithSideEffectsTriggered: {
          ...state.questionsWithSideEffectsTriggered,
          [componentId]: true,
        },
      };
    },
  },
});

const { actions, reducer } = events;

export const { handleQuestionAnswered } = actions;

export default reducer;
